import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { PortfolioFamilyId } from "../types";
const SuccessResponse = z.object({
    data: z.array(PortfolioFamilyId),
});
export const portfolioPlanArchiveURL = (abstractPortfolioId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/portfolio-plans/${abstractPortfolioId}:archive`
    : `https://middleware.uat.farther.com/investment/portfolio-plans/${abstractPortfolioId}:archive`;
export const postPortfolioPlanArchive = async (portfolioPlanId, idempotencyKey, config) => {
    const { data } = await axios.post(portfolioPlanArchiveURL(portfolioPlanId), null, {
        headers: {
            version: "20250205",
            ["idempotency-key"]: `${idempotencyKey}`,
            "Content-Type": "application/json",
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
    });
    const decoded = SuccessResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data.data;
    }
    const errorMessage = "[postPortfolioPlanArchive] Failed to archive portfolio plan";
    errorLog(postPortfolioPlanArchive.name, JSON.stringify(decoded.error.issues));
    throw new ValidationError(errorMessage, decoded.error.errors);
};
//# sourceMappingURL=postPortfolioPlanArchive.js.map